import { render, staticRenderFns } from "./editFormula.vue?vue&type=template&id=2f4a59ef&scoped=true&"
import script from "./editFormula.vue?vue&type=script&lang=js&"
export * from "./editFormula.vue?vue&type=script&lang=js&"
import style0 from "./editFormula.vue?vue&type=style&index=0&id=2f4a59ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a59ef",
  null
  
)

export default component.exports